import React, { Component } from 'react'
import { GetProdutosDetails, GetFiliaisDetails } from '../../../../services';
import PropTypes from "prop-types";

import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CFormSelect,
  CButton,
  CSpinner
} from '@coreui/react'

export default class Create extends Component {

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      Filiais: [], isLoaded: false, cd_estabelecimento: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.ListProdutos = this.ListProdutos.bind(this);
  }

  async componentDidMount() {
    this.getFiliais();
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async getFiliais() {
    let list = await GetFiliaisDetails.FilialList();
    console.log(list)
    if (list) {
      this.setState({ Filiais: list.data });
    }
  }

  async ListProdutos() {
    const { cd_estabelecimento } = this.state;
  
    if (cd_estabelecimento) {
      // Adicione aqui a lógica para listar produtos usando cd_estabelecimento
      let data = { cd_estabelecimento: cd_estabelecimento }
      GetProdutosDetails.AddProdutos(data)
      console.log("Filial selecionada:", cd_estabelecimento);
    } else {
      console.error("Nenhuma filial selecionada");
    }
  }

  render() {
    const { Filiais, isLoaded, cd_estabelecimento } = this.state;

    const headerStyles = { display: "flex", justifyContent: "space-between" };

    return (
      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader style={headerStyles}>
              Produtos
            </CCardHeader>
            <CCardBody>
              <CFormSelect
                name="cd_estabelecimento"
                value={cd_estabelecimento}
                onChange={this.handleChange}
                required
              >
                <option value="">Selecione uma filial</option>
                {Filiais.map((filial, index) => (
                  <option key={index} value={filial.cd_estabelecimento}>{filial.nome}</option>
                ))}
              </CFormSelect>

              <CButton
                style={{ flexDirection: 'row', marginTop: 10 }}
                color="success"
                width={80}
                onClick={this.ListProdutos}
              >
                Carga Produtos
              </CButton>
            </CCardBody>
          </CCard>
          {isLoaded ? <CSpinner color="success" style={{ flexDirection: 'row', marginLeft: '50%', alignItems: "center" }} /> : ''}
        </CCol>
      </CRow>
    )
  }
}
